import { produce } from 'immer'
import { compact, forEach, includes, map, remove } from 'lodash'
import { CustomLabelData } from '../apis/customLabel.api'
import { CustomLabelDataData } from '../apis/customLabelData.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'
import { TableVerticalData } from '../components/TableVertical'

const dataDownloadUrl = (
  customLabel: CustomLabelData,
  datable: CustomLabelDataData['datable']
) => {
  const isDatable = includes(customLabel.datables, datable)
  return isDatable
    ? `/customLabels/${customLabel.id}/data/${datable}/download`
    : null
}

export default {
  printsText (total: number, prints: number) {
    if (!total) return ''
    return `${prints} out of ${total} printed`
  },

  dataDownloadUrls (customLabel: CustomLabelData) {
    return {
      csv: dataDownloadUrl(customLabel, 'csv'),
      api: dataDownloadUrl(customLabel, 'api')
    }
  },

  searchOptions (customLabels: CustomLabelData[]) {
    const customLabelsData = map(customLabels, customLabel => {
      const { name, id } = customLabel
      return { id, value: name }
    })
    return compact(customLabelsData)
  },

  tableHorizontalData (
    customLabels: CustomLabelData[]
  ): TableHorizontalData<CustomLabelData>[] {
    forEach(customLabels, (customLabel: TableHorizontalData<CustomLabelData>) => {
      const actions: ActionName[] = [
        'design',
        'preview',
        'print',
        'view',
        'edit',
        'list'
      ]
      if (!customLabel.deletedAt) actions.push('delete')
      customLabel.actions = actions
      customLabel.downloadUrls = this.dataDownloadUrls(customLabel)
    })
    return customLabels
  },

  viewTableVerticalData (
    customLabel: CustomLabelData
  ): TableVerticalData {
    const { csv, api } = customLabel.printed
    return produce(customLabel, (draft: TableVerticalData) => {
      draft.csvPrints = this.printsText(csv.total, csv.printed)
      draft.apiPrints = this.printsText(api.total, api.printed)
      draft.downloadUrls = this.dataDownloadUrls(customLabel)
    })
  },

  delete (customLabels: TableHorizontalData<CustomLabelData>[], id: number) {
    return produce(customLabels, customLabels => {
      remove(customLabels, { id })
    })
  }
}
